import axios from "axios";
let baseUrl = process.env.REACT_APP_BASEURL5;
export const loginWithPassword = async ({ number, password }) => {
    try {
        const { data } = await axios.post(`${baseUrl}/app/login`, { number, password });
        return { data }
    } catch (error) {
        return { data: error }
    }
}
export const sendOtp = async ({ number }) => {
    try {
        const { data } = await axios.post(`${baseUrl}/app/phonelogin`, { number });
        return { data }
    } catch (error) {
        return { data: error }
    }
}
export const verifyOtp = async ({ number, otp }) => {
    try {
        const { data } = await axios.post(`${baseUrl}/app/verifyphonelogin`, { number, otp });
        return { data }
    } catch (error) {
        return { data: error }
    }
}